import styled from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export const MobileTilesWrapper = styled.div``;

export const TilesSection = styled.div`
    padding-bottom: 24px;
`;

export const TilesHeader = styled.div`
    align-items: flex-end;
    display: flex;
    gap: 4px;
    justify-content: space-between;
    margin-bottom: 8px;
`;

export const NicoleWrapper = styled.div`
    bottom: -12px;
    left: 16px;
    margin-left: -16px;
    margin-top: -4px;
    position: relative;
`;

export const TilesContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    position: relative;
    z-index: 1;
`;

export const TilesHeaderAction = styled.div`
    align-self: stretch;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: space-between;
    padding-top: 16px;
`;

export const SwitchToEntityMobileText = styled(Typography.TextBody_14_20)`
    text-align: center;
`;
